import React from 'react';
import './validationEsmaTable.scss';
import { reportRegime } from '../../../../infrastructure/constants/reportRegime';

const createValidationEsmaTable = (tableRows?: string[][], onChange?: (e: any, rowIndex: number, cellIndex: number) => void): JSX.Element => {

    tableRows = tableRows || [[]];

    const headers = ['', 'NEWT', 'MODI', 'VALU', 'CORR', 'TERM', 'EROR', 'REVI', 'POSC', 'MARU'];

    return (
        <div id='validationsEsmaTable'>
            <div>
                <div key='headerRow' className='display-flex'>
                    {headers.map((header: string) => {
                        return <div className='header' key={header}>{header || ''}</div>
                    })
                    }
                </div>
            </div>
            <div className='tbody'>
                {tableRows.map((row: string[], rowIndex: number) => {
                    return <div key={rowIndex} className='tr' >
                        {row.map((value: string, cellIndex: number) => {
                            return <input disabled={cellIndex > 0 && !onChange} type="text" className='td input' key={cellIndex} onChange={(e: any) => onChange ? onChange(e, rowIndex, cellIndex) : null} value={value ?? ''} />
                        })
                        }
                    </div>
                })
                }
            </div>
        </div>
    )
}

const getDetailsToBeReportedString = (regime: string): string => {

    switch (regime) {
        case reportRegime.ASIC:
        case reportRegime['ASIC Rewrite']:
            return 'Details to be reported (ASIC)';
        case reportRegime['MAS Rewrite']:
            return 'Description of data field (MAS)';
        case reportRegime['OSC Rewrite']:
            return 'Detailed Explanation of Data Element (OSC)'; 
        case reportRegime['SIX Securities']:
            return 'Description (SIX)'
        case reportRegime['SFTR']:

            return 'Details to be reported (ESMA)'
        default:
            return 'Details to be reported (ESMA)';
    }
}

const getFormatToBeReportedString = (regime: string): string => {

    switch (regime) {
        case reportRegime.ASIC:
        case reportRegime['ASIC Rewrite']:
            return 'Format to be reported (ASIC)';
        case reportRegime['MAS Rewrite']:
            return 'Field Value (MAS)'
        case reportRegime['OSC Rewrite']:
            return 'Field Value (OSC)'
        case reportRegime['SIX Securities']:
            return 'Type (SIX)'
        case reportRegime['SFTR']:
            return 'Format (ESMA)'
        default:
            return 'Format to be reported (ESMA)';
    }
}

const getValidationsString = (regime: string): string => {

    switch (regime) {
        case reportRegime.ASIC:
            return 'Validations (ASIC)';
        case reportRegime['ASIC Rewrite']:
            return 'Minimum TR validations (ASIC)'
        case reportRegime['MAS Rewrite']:
            return 'Validations (DTCC)'
        case reportRegime['OSC Rewrite']:
            return 'Validations (OSC)'
        case reportRegime['SIX Securities']:
            return 'Validations (SIX)'
        case reportRegime['SFTR']:
            return 'Validations (ESMA)'
        default:
            return 'Validations (ESMA)';
    }
}

const getFieldNumberString = (regime: string): string => {

    switch (regime) {
        case reportRegime.ASIC:
        case reportRegime['ASIC Rewrite']:
            return 'ASIC Field Number';
        default:
            return 'RTS Field Number';
    }
}

const getClassOfSpecifiedDerivativesContractsString = (regime: string): string => {

    switch (regime) {
        case reportRegime['ASIC Rewrite']:
            return 'Class of specified derivatives contracts (ASIC)';
        case reportRegime['MAS Rewrite']:
            return 'Class of specified derivatives contracts (MAS)';
        default:
            return 'Class of specified derivatives contracts';
    }
}

const getExplanatoryNotesString = (regime: string): string => {

    switch (regime) {
        case reportRegime['ASIC Rewrite']:
            return 'Explanatory notes (ASIC)';
        case reportRegime['MAS Rewrite']:
            return 'Explanatory notes (MAS)';
        default:
            return 'Explanatory notes';
    }
}

const getConditionString = (regime: string): string => {

    switch (regime) {
        case reportRegime['SIX Securities']:
            return 'Condition (SIX)';
        default:
            return '';
    }
}


const shouldShowRegimeSpecificColumn = (regime: string): boolean => {

    switch (regime) {
        case reportRegime['MAS Rewrite']:
            return true;
        default:
            return false;
    }
}


const shouldShowCondition = (regime: string): boolean => {

    switch (regime) {
        case reportRegime['SIX Securities']:
            return true;
        default:
            return false;
    }
}

export { createValidationEsmaTable, getDetailsToBeReportedString, getFormatToBeReportedString, getValidationsString, getFieldNumberString, getConditionString, getClassOfSpecifiedDerivativesContractsString, getExplanatoryNotesString, shouldShowRegimeSpecificColumn, shouldShowCondition } 
